var map = {
	"./Advisor/dev.vue": [
		"00d6",
		"chunk-2d0a3348"
	],
	"./Advisor/index.vue": [
		"ab1d3",
		"chunk-7704b649"
	],
	"./ClassroomStats/dev.vue": [
		"cbe6",
		"chunk-2d221e06"
	],
	"./ClassroomStats/index.vue": [
		"d45a",
		"chunk-2d21e012"
	],
	"./CommunicationCenter/dev.vue": [
		"f7a4",
		"chunk-2d22d93a"
	],
	"./CommunicationCenter/index.vue": [
		"a476",
		"chunk-2d208308"
	],
	"./LiveClass/dev.vue": [
		"5be2",
		"chunk-2d0d34f0"
	],
	"./LiveClass/index.vue": [
		"233b",
		"chunk-2d0b2186"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1c2a";
module.exports = webpackAsyncContext;